module.exports = __webpack_public_path__ + "media/images/people/girl-2-4e803eb211808d764c5d1aa7a525c3ee.webp";